import {createContext, useState} from "react";

export const SubjectContext = createContext({})

export const Provider = (props) => {
    const {children} = props;

    let emptySubject = {
        code: "",
        name: "",
        enabled: true,
        description: ""
    }

    const [subject, setSubject] = useState(emptySubject);
    const [subjects, setSubjects] = useState([]);
    const [submitted, setSubmitted] = useState(false);
    const [subjectDialog, setSubjectDialog] = useState(false);

    const resetSubject = () => {
        setSubject(emptySubject);
    };

    // Make the context object:
    const subjectContext = {
        subject,
        resetSubject,
        setSubject,
        subjects,
        setSubjects,
        submitted,
        setSubmitted,
        subjectDialog,
        setSubjectDialog,
    };

    // pass the value in provider and return
    return <SubjectContext.Provider value={subjectContext}>{children}</SubjectContext.Provider>;
}

export const {Consumer} = SubjectContext;
